<template>
  <div v-if="loaded">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body card-body">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <form>
                    <div class="vx-row">
                      <div class="vx-col lg:w-2/3 sm:w-2/3 w-full mt-1">
                        <div class="w-full">
                          <vs-input
                            class="inputx mb-4"
                            v-model="gridSearchData.keyword"
                            :label="$t('Search')"
                          />
                        </div>
                      </div>
                      <div class="vx-col lg:w-1/3 sm:w-1/3 w-full mt-1">
                        <label class="vs-input--label">{{
                          $t("SortingBy")
                        }}</label>
                        <div class="w-full">
                          <v-select
                            label="name"
                            :options="SortingOrderType"
                            @input="selectSortingOrderType"
                            :reduce="x => x.id"
                            ref="sortingSelected"
                            :clearable="false"
                            dir="rtl"
                          >
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <vs-button
                          type="filled"
                          class="float-right"
                          @click.prevent="submitFilter()"
                          >{{ $t("SubmitFilter") }}</vs-button
                        >
                        <vs-button
                          type="filled"
                          class="float-right ml-4"
                          id="reset-btn"
                          @click.prevent="resetForm"
                          >{{ $t("ResetFilter") }}</vs-button
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-card mb-4">
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
              <h5 class="mb-4">{{ $t("AgentQuotas") }}: {{ agentName }}</h5>
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('ProductName') },
                  { title: $t('PersianName') },
                  { title: $t('ItemCode') },
                  { title: $t('BrandName') },
                  { title: $t('ProductSegment') },
                  { title: $t('Count') },
                  { title: $t('UnitPrice') }
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 20%">
                    {{ row.agentQuotaProductInfo.productName }}
                  </td>
                  <td style="width: 18%">
                    {{ row.agentQuotaProductInfo.persianProductName }}
                  </td>
                  <td style="width: 13%">
                    {{ row.agentQuotaProductInfo.itemCode }}
                  </td>
                  <td style="width: 14%">
                    {{ row.agentQuotaProductInfo.brandInfoQuery.brandName }}
                  </td>
                  <td style="width: 15%">
                    {{ row.saleAgentQuotaSegmentInfo.segmentName }}
                  </td>

                  <td style="width: 5%">
                    {{ row.count }}
                  </td>
                  <td style="width: 12%">
                    {{ row.price.toLocaleString() }}ریال
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "saleManagement_Quotas_AgentQuotas",
  data() {
    return {
      loaded: false,
      noQuotas: false,
      gridDataSource: {
        type: "app",
        service:
          "Sales/api/QuotaTransactionsQuery/saleAgentQuotas/" +
          this.$route.params.id
      },
      gridSearchData: {},
      SortingOrderType: [
        { name: "بیش ترین سهیه", id: 1 },
        { name: "کم ترین سهمیه", id: 2 },
        { name: "بیش ترین قیمت", id: 3 },
        { name: "کمترین قیمت", id: 4 }
      ],
      agentName: ""
    };
  },
  mounted() {
    this.agentName = this.$route.query.AgentName;
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  },
  methods: {
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        SortingFieldName: "",
        SortingOrderType: ""
      };
      this.$refs.sortingSelected.clearSelection();
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    selectSortingOrderType(val) {
      if (val == 1) {
        this.gridSearchData.SortingFieldName = "Count";
        this.gridSearchData.SortingOrderType = "desc";
      }
      if (val == 2) {
        this.gridSearchData.SortingFieldName = "Count";
        this.gridSearchData.SortingOrderType = "asc";
      }
      if (val == 3) {
        this.gridSearchData.SortingFieldName = "Price";
        this.gridSearchData.SortingOrderType = "desc";
      }
      if (val == 4) {
        this.gridSearchData.SortingFieldName = "Price";
        this.gridSearchData.SortingOrderType = "asc";
      }
    }
  },
  components: {
    DataGrid,
    "v-select": vSelect
  }
};
</script>
